export default __webpack_public_path__ + "static/media/Leggings of Tranquility.97e52364.jpg";